/*
 * @package  zac-zimmerei
 * @author Danny Stark [hello@dannnystark.de]
 * services
 */

const services = {
    cfg:  {
        name: 'services',
        element: 'js-services'
    },

    log(msg) {
        // console.log(msg);
    },

    init() {
        this.log(`Init: ${this.cfg.name}`);
    }
};

export default services;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/services/_script.js